module.exports = __webpack_public_path__ + "img/LisaShaw.72a7a5f4.jpg";